import axios from "axios";

const API = axios.create({
  baseURL: "https://missionmap-lc.onrender.com/api",
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const saveFaceStatus = async (workerId, status, company, team) => {
  console.log("📡 Calling /face-status/update with:", { workerId, status, company, team });
  const response = await API.post("/face-status/update", { workerId, status, company, team });
  console.log("✅ Response from backend:", response.data);
  return response.data;
};

export const fetchFaceStatuses = async () => {
  const response = await API.get("/face-status/fetch");
  return response.data;
};
